// extracted by mini-css-extract-plugin
module.exports = {"automatic-notes-block":"styles-module__automatic-notes-block___2QdGj"};